// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2wfQy","vLegacy":"SelectSecondary_vLegacy__1Dy7x","error":"SelectSecondary_error__1GMh8","disabled":"SelectSecondary_disabled__12RD9"};